// The Certify entitlement + stage gate (docs/design/slice4-certify-ux.md §2.3). BOTH
// gates are server-side and default-deny (D36, invariant 13) - this is UI CONVENIENCE
// ONLY, selecting which takeover renders; the server's own refusal is authoritative
// whenever the real Certify routes land (§2.3 "the client reads state only to select
// CTA copy, never to decide the gate itself"). The entry points themselves (nav item,
// sub-nav tab) are NEVER hidden by this - only the destination screen's CONTENT is.
import type { Account } from "@nightcrew/shared";
import type { AppView } from "@nightcrew/shared";

export interface CertifyGateResult {
  /** True only when `account.planName` is POSITIVELY known to be "solo" - `planName`
   * is optional (CR-016, not yet resolved server-side for every account,
   * packages/shared/src/model/identity.ts:25), so an UNKNOWN plan name defaults to
   * "assume entitled" rather than guessing a refusal, the same precedent
   * `CrewAnswer.tsx`'s own `isSolo` placeholder already sets (flagged there and here -
   * the real gate is server-side regardless). */
  readonly tierDenied: boolean;
  /** True when `app.stage === "validated"` (below D34's MVP floor) - real, already-
   * fetched data (`AppView.stage`, landed), not a guess. */
  readonly stageDenied: boolean;
}

export const evaluateCertifyGate = (
  app: Pick<AppView, "stage">,
  account: Pick<Account, "planName"> | null,
): CertifyGateResult => ({
  tierDenied: account?.planName === "solo",
  stageDenied: app.stage === "validated",
});

export const isCertifyEntitled = (result: CertifyGateResult): boolean =>
  !result.tierDenied && !result.stageDenied;
